<template>
  <div class="fb-management">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'FBManagement'
  }
</script>

<style scoped>
  .fb-management {
    width: 100%;
    height: 100%;
  }
</style>
